import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Toaster } from '@knockrentals/knock-react';

import IntegrationsAPI from '../../Integrations/IntegrationsAPI';

import { BOOKS_MAPPING_STATUS, MAPPING_STATUS_CONFIG } from './constants';

import './_booksMapping.scss';

export const MappingStatus = ({
  propertyId,
  mappingStatus = BOOKS_MAPPING_STATUS.UNKNOWN,
}) => {
  const [isRefreshingBooks, setIsRefreshingBooks] = useState(false);

  const refreshBooksPropertyEntry = async () => {
    setIsRefreshingBooks(true);
    try {
      await IntegrationsAPI.refreshBooksPropertyEntry(propertyId);
      Toaster.showToast(
        `Triggered request to refresh books mappings`,
        2000,
        Toaster.ToastClasses.success
      );
    } catch {
      Toaster.showToast(
        'Error synchronizing books mapping',
        2000,
        Toaster.ToastClasses.error
      );
    }
    setIsRefreshingBooks(false);
  };

  const statusConfig =
    MAPPING_STATUS_CONFIG[mappingStatus] ||
    MAPPING_STATUS_CONFIG[BOOKS_MAPPING_STATUS.UNKNOWN];

  return (
    <div className="knock-react-flex input-auto">
      <div className="property-info-edit-field-label">Status</div>
      <div
        className="property-info-edit-field-label  icon-container"
      >
        <i
          className={statusConfig.iconClassName}
          style={{ color: statusConfig.iconColor }}
          title={statusConfig.iconTitle}
        />
        <span>{statusConfig.label}</span>
        <button
          aria-label="Synchronize Books Mapping"
          className="actionable-btn"
          disabled={isRefreshingBooks}
          onClick={refreshBooksPropertyEntry}
          type="button"
        >
          <i className="fa fa-refresh fa-fw" />
        </button>
      </div>
    </div>
  );
};

MappingStatus.propTypes = {
  propertyId: PropTypes.number.isRequired,
  mappingStatus: PropTypes.oneOf([
    BOOKS_MAPPING_STATUS.MAPPED,
    BOOKS_MAPPING_STATUS.UNMAPPED,
    BOOKS_MAPPING_STATUS.UNREGISTERED,
  ]),
};
